var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    stroke: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.5167L4 12.1116L7.46011 5.19141H24.5399L28 12.1116L16 26.5167ZM11.9385 11.5718H20.0615L17.5093 6.46749H14.4907L11.9385 11.5718ZM15.362 23.7706V12.8479H6.29185L15.362 23.7706ZM16.638 23.7706L25.7081 12.8479H16.638V23.7706ZM21.4773 11.5718H26.2824L23.7302 6.46749H18.9251L21.4773 11.5718ZM5.71761 11.5718H10.5227L13.0749 6.46749H8.26979L5.71761 11.5718Z",
    fill: "currentColor"
  })));
};

export default __webpack_public_path__ + "static/media/type_unique.91058ef3.svg";
export { SvgComponent as ReactComponent };